module.exports = __webpack_public_path__ + "static/media/ico_location.bb180563.svg";